module.exports = __webpack_public_path__ + "static/media/FloorPlan.ccd0203d.pdf";